/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css } from "@panda/css";

import { CosmosLink, CosmosText, CosmosTextVariantEnum } from "..";

export interface TextLinkProps {
	label?: string | null;
	href?: string | null;
	variant?: CosmosTextVariantEnum | null;
}

export const TextLink = ({ href = "", label, variant }: TextLinkProps): React.JSX.Element | null => {
	if (!label || !href) return null;

	return (
		<CosmosLink
			href={href}
			className={css({
				color: "eds.text.link.primary.default",
				transition: `color token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)`,
				_hover: {
					color: "eds.text.link.primary.press",
				},
			})}
			analytics={{
				eventCategory: "hyperlink",
				eventLabel: label || "",
				eventValue: {
					component: "TextLink",
					href,
				},
			}}
		>
			{<CosmosText variant={variant || CosmosTextVariantEnum.paragraphMD}>{label}</CosmosText>}
		</CosmosLink>
	);
};
